import React from 'react';
import Schedules from '../../../../pages/schedules';
import Calendars from '../../../../pages/calendars';
import Subscriber from '../../../../pages/subscriber';
import OauthLauncher from '../../../../pages/oauthLauncher';
import OauthLoading from '../../../../pages/transitions/oauthLoading';
import OauthFailed from '../../../../pages/transitions/oauthFailed';
import AlmostDone from '../../../../pages/almostdone';
import Success from '../../../../pages/success';
import HavingTrouble from '../../../../pages/havingtrouble';
import ICSLink from '../../../../pages/icslink';
import ICSLinkOutlook from '../../../../pages/icslinkOutlook';
import InAppGuide from '../../../../pages/inappGuide';


import { TransitionDirection } from './transitions';
/*
 * These views are used to allow transitions to happen, even when route Page Components haven't transitioned yet.
 */


/*
 * the initial styles are set to position the ui on the correct spot when it enters the screen
 */
function getInitStyles (astore) {
    if (astore.direction === TransitionDirection.BACK) {
        return {
            transform: 'translateX(-250px)',
            opacity: 0,
        };
    }
    return {
        transform: 'translateX(250px)',
        opacity: 0,
    };
}

function schedulesViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<Schedules 
                viewAnimation={true}
                initStyles={initStyles}
                />);
}

function calendarsViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<Calendars
                viewAnimation={true}
                initStyles={initStyles}
            />);
}

function subscriberViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<Subscriber
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function oauthLauncherViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<OauthLauncher
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function almostDoneViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<AlmostDone
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function successViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<Success
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function havingTroubleViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<HavingTrouble
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

// TODO: Remove this view in the next release since it's not used anywhere
function oauthLLoadingViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<OauthLauncher
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

/* Undone */
function icsLinkViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<ICSLink
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function icsLinkOutlookViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<ICSLinkOutlook
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function oauthLoadingViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<OauthLoading
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function oauthFailedViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<OauthFailed
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}

function inAppGuideViewRenderer (animationsStore) {
    const initStyles = getInitStyles(animationsStore);
    return (<InAppGuide
                viewAnimation={true}
                initStyles={initStyles}
            />); 
}


const views = {
    schedulesViewRenderer,
    calendarsViewRenderer,
    subscriberViewRenderer,
    oauthLauncherViewRenderer,
    almostDoneViewRenderer,
    oauthLLoadingViewRenderer,
    successViewRenderer,
    havingTroubleViewRenderer,
    icsLinkViewRenderer,
    icsLinkOutlookViewRenderer,
    oauthLoadingViewRenderer,
    oauthFailedViewRenderer,
    inAppGuideViewRenderer,
};

export default views;
